import React from 'react'

const VehiclesNoFound = () => {
  const { dictionary = {} } = window.bookingData || window.inpathData || {}

  const onButtonClick = () => {
    window.dispatchEvent(new CustomEvent('showBookingWidget'))
  }

  return (
    <div className="b-vehicles-no-found">
      <img src="/imgs/misc/search-screen.svg" alt="search-screen" />

      <div className="b-vehicles-no-found__body">
        <div className="h3">{dictionary.noResultsFoundTitle}</div>
        <div>{dictionary.noResultsFoundDescription}</div>
      </div>

      <button
        type="button"
        title={dictionary.noResultsButtonRetryText}
        className="btn btn-primary"
        style={{ width: 'auto' }}
        onClick={onButtonClick}>
        {dictionary.noResultsButtonRetryText}
      </button>
    </div>
  )
}

export default VehiclesNoFound
